export type Header =
  | 'authorization'
  | 'contact-id'
  | 'organization-id'
  | 'x-referer'
  | 'source-query'
  | 'source-path'
  | 'x-token';

export type RequestHeaders = Partial<Record<Header, string>>;

export const HEADERS: Record<string, Header> = {
  AUTHORIZATION: 'authorization',
  CONTACT_ID: 'contact-id',
  SOURCE_PATH: 'source-path',
  SOURCE_QUERY: 'source-query',
  ORGANIZATION_ID: 'organization-id',
  X_REFERER: 'x-referer',
  X_TOKEN: 'x-token',
};
